import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getVServices } from '../actions/MainAction';
export class VMeasurePage extends Component {
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        // path: data?.path?data?.path:"",
        type: this.props.type,
       
        languages:
        {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            // description:lang?.description?lang?.description:'',
            lang_id:lang_id
        },
        image_count:0,
        deleted_images:[],
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getVServices,
        afterParams:[this.props.type],
        url:'admin-vservices'
      }
    })
  }

  componentDidMount(){
    this.props.getVServices(this.props.type)
  }
  render() {
    const {vservices} = this.props;
    // console.log(services)
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title={this.props.type === "service"?"Voltmills Xidmətlər":"Ölçmə avadanlığı"} />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            vservices?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-vservices/${data?.id}`}
                  afterCallFunction={()=> this.props.getVServices()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  vservices: state.Data.vservices
});
const mapDispatchToProps = {changeStateValue, getVServices}
export default connect(mapStateToProps, mapDispatchToProps)(VMeasurePage)  